// initial state
const state = {
    infoData: {},
    referer:"",
    periodParams:{},
    tokenData:{}
};

// getters
const getters = {
    // doneTodos: state => {
    //     return state.todos + 1
    // },
};

// actions
const actions = {
    // getAllProducts({ commit, state }, products) {
    //     commit('setProducts', products)
    // }
};

// mutations
const mutations = {
    infoDataPush(state, infoData) {
        state.infoData = infoData
    },
    refererPush(state, referer){
        state.referer = referer
    },
    periodParamsPush(state, periodParams){
        state.periodParams = periodParams
    },
    tokenDataPush(state, tokenData){
        state.tokenData = tokenData
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}